import React, { FC, ReactNode, useEffect, useMemo, useState } from 'react';
import { useAuthentication } from '@johnlewispartnership/wtr-website-authentication/dist/context';
import customerOrderOrchestrationServiceClient from 'services/customerOrderOrchestration';
import usePrevious from 'hooks/use-previous';
import {
  CustomerOrderContext,
  CustomerOrderStatsContextValue,
  CustomerOrderStatsState,
} from './CustomerOrderContext';

const CustomerOrderProvider: FC<{
  children: ReactNode;
}> = ({ children }) => {
  const { state: authState } = useAuthentication();
  const [customerOrderStatsContext, setCustomerOrderStatsContext] =
    useState<CustomerOrderStatsState | null>(null);

  const previousAuthInitialised = usePrevious(authState.initialised);
  const authJustGotInitialised = !previousAuthInitialised && authState.initialised;

  useEffect(() => {
    const doEffect = async () => {
      if (authJustGotInitialised && authState.token && !authState.error) {
        const { customerOrderStats } = await customerOrderOrchestrationServiceClient.getStats({
          authHeader: authState.token.authHeader,
        });
        setCustomerOrderStatsContext(customerOrderStats);
      }
    };

    doEffect();
  }, [authJustGotInitialised, authState.error, authState.token]);

  const providerValue: CustomerOrderStatsContextValue = useMemo(
    () => ({
      customerOrderStatsContext,
      setCustomerOrderStatsContext,
    }),
    [customerOrderStatsContext, setCustomerOrderStatsContext],
  );

  return (
    <CustomerOrderContext.Provider value={providerValue}>{children}</CustomerOrderContext.Provider>
  );
};

export default CustomerOrderProvider;
